import script from "./PrimaryInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryInput.vue?vue&type=script&setup=true&lang=js"

import "./PrimaryInput.vue?vue&type=style&index=0&id=d3a7da2a&lang=scss"

const __exports__ = script;

export default __exports__